"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var ConsumerElectronics = function ConsumerElectronics(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/applications/consumer_electronics-consumer-electronics" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-consumer-electronics" + unique,
    xlinkHref: "#path-1-consumer-electronics" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-consumer-electronics" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18,10 L17,10 L17,5 L3,5 L3,13 L14,13 L14,14 L12,14 L12,15 L13.6666667,15 C13.8507616,15 14,15.2238576 14,15.5 C14,15.7761424 13.8507616,16 13.6666667,16 L6.33333333,16 C6.14923842,16 6,15.7761424 6,15.5 C6,15.2238576 6.14923842,15 6.33333333,15 L8,15 L8,14 L2.5,14 C2.22385763,14 2,13.7761424 2,13.5 L2,4.5 C2,4.22385763 2.22385763,4 2.5,4 L17.5,4 C17.7761424,4 18,4.22385763 18,4.5 L18,10 Z M16.5,12 L21.5,12 C21.7761424,12 22,12.2238576 22,12.5 L22,19.5 C22,19.7761424 21.7761424,20 21.5,20 L16.5,20 C16.2238576,20 16,19.7761424 16,19.5 L16,12.5 C16,12.2238576 16.2238576,12 16.5,12 Z M17,13 L17,19 L21,19 L21,13 L17,13 Z",
    fill: "inherit",
    id: "path-1-consumer-electronics" + unique
  }))));
};

ConsumerElectronics.propTypes = propTypes;
var _default = ConsumerElectronics;
exports["default"] = _default;